Object.assign = require('object-assign');
import {parallax} from './components/front/effects/parallax';
import {pushSoldToBottom, toggleView, setDirections, markerTargetHover} from './components/maps';
import {scrollTo} from './components/scroll-target';
import {IMAGE_URL_BASE} from './config/config';
import {uniqueId} from '../../../app/Shared/Resources/Assets/js/helpers/classesAndIds';
import {_} from 'underscore';

try {
    window.imagesJs = require('../../../app/Shared/Resources/Assets/js/helpers/images');

//window.filmroll = require('../vendor/jquery.filmroll/jquery.film_roll');

// window.Popper = require('popper.js');
//
// window._ = require('lodash');
//
// window.$ = window.jQuery = require('jquery');
// window.select2 = require('select2');
// window.Tether = require('tether');
// window.Bootstrap = require('bootstrap');
//
// window.autosize = require('autosize');
// window.Sortable = require('sortablejs');
//
    window.swipe = require('jquery-touchswipe');
    window.est = {
        scrollTo: require('./components/scroll-target').scrollTo,
        scrollToTarget: require('../../../app/Shared/Resources/Assets/js/helpers/window.tools').scrollToTarget
    };
} catch (e) {
    console.error('e', e);
}

$.fn.extend({
    setImageDefault: function (options) {
        let settings = {
                replacement_element_type: 'span',

                target_class: 'image-preload',
                replaced_image_base_class: 'img-replaced',
            },
            removeEmptyElements = function (compiled_array) {
                let newArray = [];

                for (let i = 0; i < compiled_array.length; i++) {
                    if (compiled_array[i]) {
                        newArray.push(compiled_array[i]);
                    }
                }
                return newArray.join(' ');
            },
            cleanUpWords = function (word) {
                let submitted_word_array = [],
                    newArray = [],
                    arrayToString = String,
                    compiled_array = []
                ;

                if (typeof submitted_word_array === 'string' || submitted_word_array instanceof String) {
                    submitted_word_array = word.split(' ');
                } else if (submitted_word_array && typeof submitted_word_array === 'object' && submitted_word_array.constructor === Array) {
                    submitted_word_array = word;
                } else {
                    console.error('String or array is expected');
                }
                // if(value && typeof value === 'object' && value.constructor === Object){
                //
                // }
                arrayToString = submitted_word_array.join(' ');
                compiled_array = removeEmptyElements(arrayToString.split(' '));
                return compiled_array;
            };

        settings = Object.assign(settings, options);

        // console.log($(this), 'setImageDefault', 'defaultImage', defaultImage);
        // let setImage = defaultImage;
        $(this).each(function (i, element) {
            // console.log('each', 'i', i, 'v', element);

            window.imagesJs.imageExists(element.src,
                function () {
// console.log('success', element.src);
                },
                function () {
                    //v.src = IMAGE_URL_BASE.default_team_image_url
                    let target = $(element);

                    // console.log('', 'x', target.attr('data-default_set'));
                    if (!(typeof target.attr('data-default_set') !== 'undefined' && target.attr('data-default_set') !== null)) {
                        let id = uniqueId('image');

                        target
                            .attr('data-default_set', true)
                            .attr('id', id);

                        let replacement_text_from_alt = target.attr('alt'),
                            elementType = (typeof target.attr('data-image-element_type') !== 'undefined' && target.attr('data-image-element_type') !== null)
                                ? target.attr('data-image-element_type')
                                : settings.replacement_element_type
                            ,
                            elementClass = typeof target.attr('data-image-element_class') !== 'undefined' && target.attr('data-image-element_class') !== null
                                ? target.attr('data-image-element_class')
                                : '',
                            replacementClasses = settings.target_class,
                            cleanedClasses = cleanUpWords([
                                settings.replaced_image_base_class,
                                replacementClasses + '--' + settings.replaced_image_base_class,
                                elementClass
                            ]);
                        console.log('imageExists->replaced', 'cleanedClasses', cleanedClasses);
                        target
                            .after('<' + elementType
                                + ' class="'
                                + cleanedClasses
                                + '">'
                                + replacement_text_from_alt
                                + '</' + elementType + '>')
                            .remove();

                        // $('span')
                        // 	.text(alt)
                        // 	.appendTo($('#'+id).parent());

                        // .hide();
                    }

                });

        });
        return {};
    }
});

$('.image-preload').setImageDefault({target_class: 'image-preload'});

$.fn.extend({
    toggleText: function (a, b) {
        return this.text(this.text() == b ? a : b);
    },

    /**
     * Remove element classes with wildcard matching. Optionally add classes:
     *   $( '#foo' ).alterClass( 'foo-* bar-*', 'foobar' )
     *
     */
    alterClass: function (removals, additions) {

        var self = this;

        if (removals.indexOf('*') === -1) {
            // Use native jQuery methods if there is no wildcard matching
            self.removeClass(removals);
            return !additions ? self : self.addClass(additions);
        }

        var patt = new RegExp('\\s' +
            removals.replace(/\*/g, '[A-Za-z0-9-_]+').split(' ').join('\\s|\\s') +
            '\\s', 'g');

        self.each(function (i, it) {
            var cn = ' ' + it.className + ' ';
            while (patt.test(cn)) {
                cn = cn.replace(patt, ' ');
            }
            it.className = $.trim(cn);
        });

        return !additions ? self : self.addClass(additions);
    }

});
// $(".carousel").swipe({
//
// 	swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
//
// 		if (direction == 'left') {
// 			$(this).carousel('next');
// 		}
// 		if (direction == 'right') {
// 			$(this).carousel('prev');
// 		}
// 	},
// 	allowPageScroll: "vertical"
//
// });
// require('hideshowpassword');
//
// try{
// 	Dropzone = require('dropzone');
// 	password = require('password-strength-meter');
// }
// catch (e){
// 	console.log("Dropzone was not loaded");
// }

// scrollTo($('#card-list'), 0.5, dataTarget);
// (function () {
// 	$.fn.scrollTargetWithOffset = function (method /*, args*/) {
// 		let methods = { // object holding your methods
// 			'bar': function () {
// 				// console.log('bar', this);
// 				return this;
// 			},
// 			'foobar': function () {
// 				// console.log('foobar', this);
// 				return this;
// 			}
// 		};
// 		return methods[method].apply(
// 			this,
// 			Array.prototype.slice.call(arguments, 1) // pass your args
// 		);
// 	};
// 	$('something').scrollTargetWithOffset('bar')
// })();

/*

 appId: bfcd307a4fb118ee
 key: 75a1215b28f531cc5f7c24a9af1adee9

 */

if ($('.parallax')) {
    parallax();
}
document.addEventListener('DOMContentLoaded', function (event) {
    let routeName = $('body').attr('data-route');
    if (routeName === 'event.products') {
        pushSoldToBottom();
        toggleView();
        setDirections();
        markerTargetHover();
    }
    if (window.location.hash) {

        setTimeout(function () {
            let potential_scroll = window.location.hash.substring(1);
            //Puts hash in variable, and removes the #
            // character
            if (document.getElementById(potential_scroll) !== null) {
                window.est.scrollToTarget(potential_scroll);

            }
        }, 1000);

    }
    $(document).ready(function () {
        $('.table-of-contents--list-item--anchor')
            .click(function (e) {
                e.preventDefault();
                window.est.scrollToTarget(this.hash.substr(1))
            })
    });
});






// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js